import React from "react";

import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import { isEqual } from "lodash";

import {
  ColorPaletteColorsCollapsibleContainer,
  ColorPalettesCheckContainer,
  ColorPalettesColors,
  ColorPalettesColorsCollapsibleHeading,
  ColorPalettesColorsContainer,
  ColorPalettesColorsHeading,
  ColorPalettesColorTile,
  ColorPalettesContainer,
  ColorPalettesHeader,
  ColorPalettesHeading,
  ColorPalettesParagraph,
} from "./styles";
import { getOpticsColors, getOwnColors } from "./colors";
import { useOpticsStore } from "../../../stores/use-optics-store";
import { ColorCheckIcon } from "../icons/ColorCheck";

const ColorPalettes = () => {
  const {
    styleguideSetup: { selectedColors },
    colorPalette,
    setColorPalette,
  } = useOpticsStore((state) => ({
    styleguideSetup: state.styleguideSetup,
    colorPalette: state.colorPalette,
    setColorPalette: state.setColorPalette,
  }));
  const { t } = useTranslation();
  const theme = useTheme();

  const ownColors = getOwnColors({ ownColors: selectedColors });
  const opticsColors = getOpticsColors();

  return (
    <ColorPalettesContainer>
      <ColorPalettesHeader>
        <ColorPalettesHeading>{t("pick-a-color-palette")}</ColorPalettesHeading>
        <ColorPalettesParagraph>
          {t("it-will-be-applied-to-the-templates")}
        </ColorPalettesParagraph>
      </ColorPalettesHeader>

      {ownColors && (
        <ColorPalettesColorsContainer>
          <ColorPalettesColorsHeading>
            {t("your-colors")}
          </ColorPalettesColorsHeading>
          <ColorPalettesColors>
            {ownColors.map((colors) => (
              <ColorPalettesColorTile
                isSelected={isEqual(colorPalette, colors)}
                accentColor={colors.accent[theme.name]}
                textColor={colors.text[theme.name]}
                onClick={() => setColorPalette(colors)}
              >
                Aa
                {isEqual(colorPalette, colors) && (
                  <ColorPalettesCheckContainer>
                    <ColorCheckIcon />
                  </ColorPalettesCheckContainer>
                )}
              </ColorPalettesColorTile>
            ))}
          </ColorPalettesColors>
        </ColorPalettesColorsContainer>
      )}

      <ColorPaletteColorsCollapsibleContainer open={!ownColors}>
        <ColorPalettesColorsCollapsibleHeading>
          {t("optics-colors")}
        </ColorPalettesColorsCollapsibleHeading>
        <ColorPalettesColors>
          {opticsColors.map((colors) => (
            <ColorPalettesColorTile
              isSelected={isEqual(colorPalette, colors)}
              accentColor={colors.accent[theme.name]}
              textColor={colors.text[theme.name]}
              onClick={() => setColorPalette(colors)}
            >
              Aa
              {isEqual(colorPalette, colors) && (
                <ColorPalettesCheckContainer>
                  <ColorCheckIcon />
                </ColorPalettesCheckContainer>
              )}
            </ColorPalettesColorTile>
          ))}
        </ColorPalettesColors>
      </ColorPaletteColorsCollapsibleContainer>
    </ColorPalettesContainer>
  );
};

export default ColorPalettes;
